import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import Quill from 'quill';
import { Mention, MentionBlot } from "quill-mention";

@Component({
    selector: 'rosie-custom-greeting-editor',
    templateUrl: './custom-greeting-editor.component.html',
    styleUrls: ['./custom-greeting-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomGreetingEditorComponent implements OnInit {
  isEditorInitialized = false;
  @Input() customGreeting = '';
  @Input() customGreetingControl: FormControl;
  @Input() isLegalDisclaimerEnabled;
  @ViewChild('editor') editorComponent;

  editorModules = {
    mention: {
      mentionDenotationChars: [':'],
      source: (searchTerm, renderList) => {
        const mentionPatterns = [
          { key: 'Agent Name', value: 'Agent Name' },
          { key: 'Company Name', value: 'Company Name' },
          { key: 'Legal Disclaimer', value: 'Legal Disclaimer' },
        ];

        if (searchTerm.length === 0) {
          renderList(mentionPatterns, searchTerm);
        } else {
          const matches = mentionPatterns.filter(item =>
            item.value.toLowerCase().includes(searchTerm.toLowerCase())
          );
          renderList(matches, searchTerm);
        }
      },
    },
    toolbar: false,
  };
  formats = ["bold", "italic", "mention"];

  constructor() {
    Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
  }

  ngOnInit() {
  }

  getEditor() {
    return this.editorComponent?.quillEditor;
  }

  handleCustomGreetingChange() {
    const plainText = this.getPlainTextFromEditor();
    this.customGreetingControl.patchValue(plainText);
  }

  getPlainTextFromEditor() {
    const ops = this.getEditor().getContents()?.ops;
    let result = ops.reduce((acc, op) => {
      if (typeof op.insert === 'string') {
        return acc + op.insert;
      } else if (typeof op.insert === 'object' && op.insert.mention) {
        return acc + op.insert.mention.value;
      }
      return acc;
    }, '');
    result = result.replace(/Company Name/g, ':business_name')
      .replace(/Agent Name/g, ':agent_name')
      .replace(/Legal Disclaimer/g, ':legal_disclaimer');
    result = result.replace(/(:business_name|:agent_name|:legal_disclaimer) (\.|,|!|\?)/g, '$1$2');
    result = result.replace(/ +(?= )/g, '');
    return result.trim();
  }

  insertMentionTag(tag: any) {
    const editor: any = this.getEditor();
    const mentionModule = editor.getModule('mention');

    mentionModule.insertItem({ id: tag.key, value: tag.value }, true, { showDenotationChar: false })
  }

  onContentChanged() {
    this.handleCustomGreetingChange();
  }

  detectAndTransformMentions() {
    const editor = this.getEditor();
    const content = editor.getText();

    editor.getModule('mention').openMenu(':');
    editor.blur();
    editor.setText(content);

    this.initializeQuill();
    const mentionPatterns = [
      { key: 'Agent Name', value: 'Agent Name' },
      { key: 'Company Name', value: 'Company Name' },
      { key: 'Legal Disclaimer', value: 'Legal Disclaimer' },
    ];

    const mentionsToInsert = [];

    mentionPatterns.forEach(mention => {
      let index = content.indexOf(mention.key);
      while (index !== -1) {
        mentionsToInsert.push({ index, mention });
        index = content.indexOf(mention.key, index + 1);
      }
    });

    mentionsToInsert.sort((a, b) => b.index - a.index);

    mentionsToInsert.forEach(({ index, mention }) => {
      editor.deleteText(index, mention.key.length);
      editor.setSelection(index);
      this.insertMentionTag(mention);
    });

    const ops = editor.getContents().ops;
    const lastMeaningfulOpIndex = ops.length - 1;
    let meaningfulIndex = lastMeaningfulOpIndex;

    while (meaningfulIndex >= 0) {
      const op = ops[meaningfulIndex];
      if (typeof op.insert === 'object' && op.insert.mention) {
        break;
      }
      if (typeof op.insert === 'string' && op.insert.trim() !== '') {
        break;
      }
      meaningfulIndex--;
    }
    const lastMeaningfulOp = ops[meaningfulIndex];
    if (lastMeaningfulOp && typeof lastMeaningfulOp.insert === 'object' && lastMeaningfulOp.insert.mention) {
      editor.insertText(editor.getLength() - 1, '\u200B');
    }

    editor.setSelection(editor.getLength());
  }

  initializeQuill() {
    if (this.isEditorInitialized) {
      return;
    }
    this.isEditorInitialized = true;
  }

  setText(text) {
    this.getEditor().setText(text);
  }
}
